exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_basket_1a6H9eRAt-g_OxQfG72NG2 {\n  width: 150px;\n  height: 83px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  background-image: url(https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/easter-confetti/basket.png);\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  z-index: 40000002;\n  font-size: 28px;\n  color:antiquewhite;\n  line-height: 53px;\n  text-align: center;\n  padding-top: 30px;\n  box-sizing: border-box;\n}", ""]);

// Exports
exports.locals = {
	"IA_basket": "IA_basket_1a6H9eRAt-g_OxQfG72NG2"
};